import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from "@mui/material";
import { FormattedMessage } from 'react-intl';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function FreeTrialDialog({
  open,
  onAddDevice,
  onAddLater,
  onClose
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2
        }
      }}
    >
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
          gap={2}
        >
          {/* Icon */}
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              backgroundColor: "#E6F7F2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <CheckCircleIcon sx={{ color: "#1DBE9F", fontSize: 32 }} />
          </Box>

          {/* Title */}
          <Typography variant="h2" fontWeight={600}>
            <FormattedMessage id="readyToGetStarted" />
          </Typography>

          {/* Subtitle */}
          <Typography variant="body2" color="text.secondary">
            <FormattedMessage id="addFirstDeviceToActivateFreeTrial" />
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", gap: 1.5, pb: 2 }}>
        <Button variant="outlined" onClick={onAddLater}>
            <FormattedMessage id="willAddLater" />
        </Button>

        <Button
          variant="contained"
          onClick={onAddDevice}
        >
            <FormattedMessage id="addDevice" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
